<template>
  <div :class="{'step-card':true,'step-card-selected':selected,'unexecuted':unexecuted,'modified':step.modified}">
    <div class="step-header">
      <span v-if="step.isCurrent" class="curr-icon-container">
        <i class="el-icon-ali-arrow_rt" />
      </span>
      <!-- <i v-else class="icon el-icon-ali-weizhidangqian" /> -->
      <span v-else class="step-num">{{ stepIndex + 1 }}</span>
    </div>
    <div class="step-name" @dblclick="beginEdit">
      <!-- <div class="step-date" v-if="step.beginDate">{{ step.beginDate }} - {{ step.endDate }}</div> -->
      <div class="step-text" v-show="!editing">{{ step.stepName }}</div>
      <input v-show="editing" ref="stepNameInput" v-model.trim="step.stepName" @blur="endEdit" />
    </div>
    <div
      v-if="checkable"
      :class="{
        'step-check': true,
        checked: step.checked,
        'el-icon-check': step.checked
      }"
      @click.stop="toggleCheck"
    />
  </div>
</template>

<script>
import { nextTick } from 'q';
export default {
  components: {},
  mixins: [],
  props: {
    /** 未执行的（针对项目执行阶段） */
    unexecuted: {
      type: Boolean,
      default: false
    },
    /** 选中 */
    selected: {
      type: Boolean,
      default: false
    },
    /** 名称可编辑 */
    editable: {
      type: Boolean,
      default: false
    },
    /** 可勾选 */
    checkable: {
      type: Boolean,
      default: false
    },
    /** 步骤数据对象 */
    step: {
      type: Object
    },
    /** 步骤序列 */
    stepIndex: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      editing: false
      // checked: true
    };
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  destroyed() {},
  methods: {
    beginEdit() {
      if (this.editable) this.editing = true;

      this.$nextTick(()=>{
        this.$refs.stepNameInput.focus();
      })
    },
    endEdit() {
      this.editing = false;
    },
    toggleCheck() {
      this.step.checked = !this.step.checked;
    }
  }
};
</script>
<style lang="scss" scoped>
$radius: 5px;

$defaultColor: #4e92d5;
$defaultFontColor: #306aa3;

$selectedColor: #f5a623;
$selectedFontColor: #b17f2d;

$unexecutedColor: #c1c8cc;
$unexecutedFontColor: #979797;

$contentFontSize: 16px;

// 禁止选中
@mixin selectedDisabled {
  -moz-user-select: none; /*火狐*/
  -webkit-user-select: none; /*webkit浏览器*/
  -ms-user-select: none; /*IE10*/
  -khtml-user-select: none; /*早期浏览器*/
  user-select: none;
}

.step-card {
  @include selectedDisabled;
  width: 200px;
  height:50px;
  border: 1px solid $defaultColor;
  border-radius: $radius;
  position: relative;
  display: flex;

  // 卡片头部
  .step-header {
    display: flex;
    width:41px;
    align-items: center;
    justify-content: center;
    font-size: 16px;
    color: white;
    text-align: center;
    height:calc(100%+2px);
    background-color: $defaultColor;
    border-top-left-radius: $radius;
    border-bottom-left-radius: $radius;
    //margin: -1px -1px 0 -1px;
    margin:-1px 0 -1px -1px;

    .curr-icon-container {
      display: block;
      width: 22px;
      height: 22px;
      border-radius: 50%;
      background-color: white;
      display: flex;
      align-items: center;
      justify-content: center;
      padding-right:1px;
      box-sizing: border-box;

      i{
        color:$selectedColor;
        font-size: 15px;
      }
    }

    .icon {
      font-size: 16px;
      margin-right: 8px;
    }
  }

  // 卡片内容
  .step-name {
    border-top-right-radius: $radius;
    border-bottom-right-radius: $radius;
    height: 100%;
    background-color: #eceff9;
    color: $defaultFontColor;
    font-size: $contentFontSize;

    flex:1;
    min-width: 0;
    display: flex;
    text-align: center;
    flex-direction:column;
    justify-content: center;

    // .step-date{
    //   color:#65798C;
    //   font-size:12px;
    //   margin-bottom:2px;
    // }

    .step-text{
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
      line-height: 24px;
    }

    input {
      color: $defaultFontColor;
      font-size: $contentFontSize;

      caret-color: black;

      text-align: center;
      width: 100%;
      height: 100%;
      border-top-right-radius: $radius;
      border-bottom-right-radius: $radius;
      border: none;
      padding: 0;
      outline: none;
    }
  }

  // 卡片勾选
  .step-check {
    width: 22px;
    height: 22px;
    position: absolute;
    top: -12px;
    right: 12px;
    border-radius: 50%;
    box-sizing: border-box;
    box-shadow: 0px 2px 4px 0px rgba(14, 14, 80, 0.36);
    border: 1px solid rgba(237, 237, 237, 1);
    background: white;
    cursor: pointer;

    &.checked {
      background: #1d4283;
      border: solid 1px #1d4283;
      box-shadow: none;
      color: white;
      font-size: 16px;
      text-align: center;
      line-height: 22px;
    }
  }
}

.unexecuted {
  border-color: $unexecutedColor;
  .step-header {
    background-color: $unexecutedColor;
  }
  .step-name {
    color: $unexecutedFontColor;
    input {
      color: $unexecutedFontColor;
    }
  }
}

.step-card:hover {
  border-color: $selectedColor;
  .step-header {
    background-color: $selectedColor;
  }
  .step-name {
    color: $selectedFontColor;
    input {
      color: $selectedFontColor;
    }
  }
}

.step-card-selected {
  box-shadow: 0px 4px 20px rgba(57, 38, 6, 0.3);
  -webkit-box-shadow: 0px 4px 20px rgba(57, 38, 6, 0.3);
  -moz-box-shadow: 0px 4px 20px rgba(57, 38, 6, 0.3);

  border-color: $selectedColor;
  .step-header {
    background-color: $selectedColor;
  }
  .step-name {
    background-color: white;
    color: $selectedFontColor;
    input {
      color: $selectedFontColor;
    }
  }
}

.modified{
  border-color: red;
  .step-header {
    background-color: red;
  }
  .step-name {
    color: red;
    input {
      color: red;
    }
  }
}
</style>
